module.exports = {"id":"172114","name":"Diego Valeri","rating":"80","photo":"./data/images/photos/3/172114.png","club":{"name":"Portland","logo":"./data/images/clubs/Portland.png"},"positions":["MOC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoValeri0.json
// module id = 1098
// module chunks = 0